import { Sequence } from "../audio/Sequence.js";
import { TimelineAddOptions } from "../display/Timeline.js";
import { TimelineItem } from "../display/TimelineItem.js";
import { VOEmoji } from "./DataStructure.js";

export interface TokenHandlerOptions {
    sequence: Sequence<TimelineItem>;
    emojis: VOEmoji[];
}

type TokenHandlerParser = (data: string, emojis: VOEmoji[]) => TimelineAddOptions[];

export class TokenHandler {
    private _versionSeparator: string = "A";
    private _version: string = "1.0.0";
    private _emojis: VOEmoji[];
    private _sequence: Sequence<TimelineItem>;
    private _parsers: { [version: string]: TokenHandlerParser } = {};

    constructor(options: TokenHandlerOptions) {
        options = e5.object.merge({

        }, options);

        this._emojis = options.emojis;
        this._sequence = options.sequence;

        this._parsers["1.0.0"] = (data, emojis) => {
            if (!data) {
                return [];
            }            

            const itemSeparator: string = "B";
            const valueSeparator: string = "C";

            const result: TimelineAddOptions[] = [];
            const items = data.split(itemSeparator);
            for (const item of items) {
                const values = item.split(valueSeparator);
                const emoji = e5.array.id(emojis, parseInt(values[0]));
                if (!emoji) {
                    //TODO: show error
                    continue;
                }
                result.push({
                    emoji,
                    lineIndex: parseInt(values[1]),
                    speed: parseFloat(values[2])
                });
            }

            return result;
        }

        options.sequence.onChangeItems.debounce(() => {
            const token = this.getToken();
            const url = e5.Url.params.set("token", token);
            window.history.replaceState(null, null, "?" + url.split("?").slice(1).join(""));
        }, 500);
    }

    public getToken(): string {
        const itemSeparator: string = "B";
        const valueSeparator: string = "C";
        const items: string[] = [];
        for (let item of this._sequence.items) {
            let values = [
                item.emoji.id,
                item.lineIndex,
                item.speed.toFixed(1)
            ];
            items.push(values.join(valueSeparator));
        }
        return this._version + (items.length > 0 ? this._versionSeparator : "") + items.join(itemSeparator);
    }

    public parseToken(token: string): TimelineAddOptions[] {
        if (!token) {
            return [];
        }

        const split = token.split(this._versionSeparator);
        const version = split[0];

        if (!version) {
            console.warn("Could not parse token with empty data-version.");
            return [];
        }

        if (typeof this._parsers[version] !== "function") {
            console.warn("Could not parse token with version", version);
            return [];
        }

        const data = split[1];
        return this._parsers[version](data, this._emojis);
    }

    public parseTokenFromUrl(): TimelineAddOptions[] {
        return this.parseToken(e5.Url.params.get("token", ""));
    }
}